import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IContragentBadAdd } from './interfaces';

export const getContragentBadAddList = (data: IDynamicTableParams) => {
  return instance()
    .post<IContragentBadAdd[]>('/dictionary/contragentBadAdd/list', data)
    .then((response) => response.data);
};

export const getContragentBadAddAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/dictionary/contragentBadAdd/availableColumns')
    .then((response) => response.data);
};

export const getContragentBadAddAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/dictionary/contragentBadAdd/availableGroupColumns')
    .then((response) => response.data);
};

export const loadContragentBadAdd = (contragentBadAddId: number) => {
  return instance()
    .post<IContragentBadAdd>('/dictionary/contragentBadAdd/load/' + contragentBadAddId)
    .then((response) => response.data);
};

export const createContragentBadAdd = (contragentBadAdd: IContragentBadAdd) => {
  return instance()
    .post<IContragentBadAdd>('/dictionary/contragentBadAdd/create', contragentBadAdd)
    .then((response) => response.data);
};

export const updateContragentBadAdd = (contragentBadAddId: number, contragentBadAdd: IContragentBadAdd) => {
  return instance()
    .post<IContragentBadAdd>('/dictionary/contragentBadAdd/update/' + contragentBadAddId, contragentBadAdd)
    .then((response) => response.data);
};

export const archiveContragentBadAdd = (contragentBadAddId: number, isDeleted: boolean) => {
  return instance()
    .post(`/dictionary/contragentBadAdd/deleted/${contragentBadAddId}`, { isDeleted })
    .then((response) => response.data);
};
